<template>
  <div
    class="messenger-search"
    :class="{'is-opened': isOpened}"
    ref="search"
    @click.stop
  >
    <div class="messenger-search__input">
      <div class="messenger-search-input-tags__wrap">
        <div class="messenger-search-input-tags">
          <div
            v-if="selectedTags.length"
            class="flex"
          >
            <messenger-tag
              v-for="tag in selectedTags"
              class="mr-1"
              :key="tag.slug"
              :tag="tag"
              @delete="removeTag(tag)"
            />
          </div>
        </div>
      </div>
      <div class="messenger-search-input-text">
        <input
          type="text"
          ref="input"
          v-model="querySearch"
          :placeholder="selectedTags.length ? '' : 'Поиск в чатах по имени, телефону, тэгам и email'"
          @keyup.delete="onDelete"
          @keyup.esc="close"
          @keyup.enter="onSearch"
          @focus="open"
          @input="onInput"
        >
        <div class="messenger-search-input-text__icons">
          <button
            v-if="isOpened"
            class="messenger-search-input-text-icon"
            @click.prevent="onClear"
          >
            <feather-icon
              icon="XIcon"
            />
          </button>
          <button
            class="messenger-search-input-text-icon"
            @click.prevent="onSearch"
          >
            <feather-icon
              icon="SearchIcon"
            />
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="tags.length > 0"
      class="messenger-search__dropdown"
    >
      <div class="messenger-search-tags">
        <div class="messenger-search-tags__title">Поиск по тэгам</div>
        <div class="messenger-search-tags__list">
          <div class="flex flex-wrap">
            <messenger-tag
              v-for="tag in tags"
              class="mr-1 mb-1"
              :key="tag.slug"
              :tag="tag"
              :no-delete="true"
              @click="addTag(tag)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import  { mapGetters,  mapActions } from 'vuex'
import Tag from '@/api/http/models/Tag'

import MessengerTag from '@/components/MessengerTag.vue'

export default {
  components: {
    MessengerTag
  },
  data () {
    return {
      isOpened: false,
      tags: [],
      selectedTags: [],
      querySearch: '',
      deleteFlag: false
    }
  },
  computed: {
    ...mapGetters(['authUserCompany', 'querySearchTags', 'querySearchText'])
  },
  mounted () {
    document.body.addEventListener('click', this.onClickBody)
  },
  watch: {
    '$route.query': {
      deep: true,
      handler (newValue) {
        if (!newValue.tags && !newValue.search) {
          this.reset()
        }
      }
    }
  },
  async created () {
    if (this.$route.query.tags) {
      await this.fetchTags()

      const queryTags = this.$route.query.tags.split(',')

      this.selectedTags = this.tags.filter(tag => queryTags.includes(tag.slug))
    }

    if (this.$route.query.search) {
      this.querySearch = this.$route.query.search
    }
  },
  methods: {
    ...mapActions(['addSearchTags', 'addSearchText']),

    async fetchTags () {
      const response = await Tag.getAll(this.authUserCompany.slug)

      this.tags = response.data || []
    },
    onClickBody () {
      this.close()
    },
    close () {
      this.isOpened = false
      this.$refs.input.blur()
    },
    open () {
      this.isOpened = true
      this.fetchTags()
    },
    addTag (tag) {
      const index = this.selectedTags.findIndex(sel => sel.slug === tag.slug)
      if (index === -1) {
        this.selectedTags.push(tag)
      }
      this.$refs.input.focus()
      this.search()
    },
    removeTag (tag) {
      const index = this.selectedTags.findIndex(sel => sel.slug === tag.slug)
      if (index !== -1) {
        this.selectedTags.splice(index, 1)
      }
      if (this.selectedTags.length === 0) {
        this.close()
      }
      this.search()
    },
    onDelete () {
      const caretPosition = this.$refs.input.selectionStart

      if (caretPosition === 0 && this.deleteFlag && this.selectedTags) {
        this.selectedTags.splice(-1, 1)
        this.search()
      }

      if (caretPosition === 0 && !this.deleteFlag) {
        this.deleteFlag = true
      } else {
        this.deleteFlag = false
      }
    },
    onClear () {
      this.reset()
      this.close()
      this.search()
    },
    onInput () {
      const regExp = /#.*\s/gi
      const textTag = this.querySearch.match(regExp)
      if (textTag && textTag[0]) {
        const queryTag = textTag[0].toLowerCase().trim().substring(1)
        const tag = this.tags.find(tag => tag.title.toLowerCase() === queryTag)
        if (tag) {
          this.addTag(tag)
          this.querySearch = this.querySearch.replace(regExp, '')
        }
      }
    },
    onSearch () {
      this.close()
      this.search()
    },
    search () {
      const query = {}
      const queryTags = this.selectedTags.map(tag => tag.slug).join() || undefined
      const querySearch = this.querySearch || undefined

      if (queryTags) {
        query.tags = queryTags
      }

      if (querySearch) {
        query.search = querySearch
      }

      if (
        queryTags !== this.$route.query.tags
        || querySearch !== this.$route.query.search
      ) {
        this.$router.push({
          name: this.$route.name,
          query
        })
      }

      this.addSearchTags(this.selectedTags)
      this.addSearchText(this.querySearch)
    },

    reset () {
      this.selectedTags = []
      this.querySearch = ''

      this.addSearchTags([])
      this.addSearchText('')
    }
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.onClickBody)
  }
}
</script>
